import { CompactUserResponse } from '@business/entities/account';
import { ChecklistId } from '@business/entities/checklist';
export enum ChecklistRecurring {
  oneTime = 'one-time',
  daily = 'daily',
  weekly = 'weekly',
  monthly = 'monthly',
  yearly = 'yearly',
}

export type TemplateStatus = 'completed' | 'needAction' | 'notActionable' | 'overDue';

export type ChecklistTemplateId = string;

export interface ChecklistTemplateStepResponse {
  id: number;
  name: string;
  menuOrder: number;
  link: string | null;
  instructions: string | null;
  assignedTo: string | null;
  assignee?: string[];
  subSteps: ChecklistTemplateStepResponse[];
  completedAt: number;
  completedBy?: CompactUserResponse | null;
}

export interface ChecklistTemplateSectionResponse {
  id: number;
  name: string;
  menuOrder: number;
  steps: ChecklistTemplateStepResponse[];
  assignee: string[];
}

export interface ChecklistTemplateResponse {
  id: ChecklistTemplateId;
  title: string;
  description: string;
  isSequential: boolean;
  recurring: ChecklistRecurring;
  date: number;
  sections: ChecklistTemplateSectionResponse[];
  templateId: ChecklistTemplateId;
  assignee: string[];
  progress: number;
  isCompleted: boolean;
  steps: ChecklistTemplateStepResponse[];
  completeStepsOrder: CompleteStepsOrder;
  watchers: string[];
  dueDate: number;
  dueDatePassed: boolean;
  createdAt: number;
  isParent: boolean;
  instanceDates: instanceDateResponse[];
  stepsStatus: string;
  filterDates: ChecklistFilterDateResponse[];
  children: number;
  isDeleted: boolean;
  days: number[];
}

export interface ChecklistFilterDateResponse {
  id: ChecklistTemplateId;
  date: number;
  name: string;
}
export interface instanceDateResponse {
  id: ChecklistId;
  date: number;
}

export type CompactChecklistTemplateResponse = Omit<ChecklistTemplateResponse, 'sections'>;

export enum CompleteStepsOrder {
  same = 'same',
  individual = 'individual',
}

export enum SortByOptions {
  dueDate = 'duedate',
  title = 'title',
  dateAdded = 'dateadded',
}

export enum SortByDirections {
  asc = 'asc',
  desc = 'desc',
}

export interface ChecklistParentResponse {
  id: ChecklistTemplateId;
  title: string;
  description: string;
  assignee: string[];
  templateId: ChecklistTemplateId;
  completeStepsOrder: CompleteStepsOrder;
  watchers: string[];
  instanceDates: instanceDateResponse[];
  stepsStatus: string;
  filterDates: ChecklistFilterDateResponse[];
}
